import { render, staticRenderFns } from "./PlusoneGiftCard.vue?vue&type=template&id=21cd20b6&lang=pug&"
import script from "./PlusoneGiftCard.vue?vue&type=script&lang=ts&"
export * from "./PlusoneGiftCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports